// extracted by mini-css-extract-plugin
export var aria_btn = "factory-module--aria_btn--eb8f3";
export var arrowbtn = "factory-module--arrowbtn--76724";
export var bodycopy = "factory-module--bodycopy--8719d";
export var bordered = "factory-module--bordered--eb6d0";
export var calloutLandingTiles = "factory-module--callout-landing-tiles--ff221";
export var cont = "factory-module--cont--7fb54";
export var desk = "factory-module--desk--cb5a2";
export var desk_last = "factory-module--desk_last--10a6e";
export var fact_fixed = "factory-module--fact_fixed--57214";
export var factory = "factory-module--factory--a9c61";
export var fig = "factory-module--fig--c2589";
export var fig1 = "factory-module--fig1--c2afb";
export var figcap = "factory-module--figcap--b6d04";
export var hero = "factory-module--hero--54f2b";
export var img = "factory-module--img--5e8c7";
export var makers = "factory-module--makers--7379b";
export var mobi = "factory-module--mobi--249fb";
export var more = "factory-module--more--ac6bb";
export var moretxt = "factory-module--moretxt--2783a";
export var moretxt_wr = "factory-module--moretxt_wr--eed1f";
export var nd_ctaLink = "factory-module--nd_cta-link--3e859";
export var prods = "factory-module--prods--04eb6";
export var product_tileArrows = "factory-module--product_tile-arrows--17dae";
export var scroll = "factory-module--scroll--08867";
export var scrollt = "factory-module--scrollt--14c0a";
export var sec = "factory-module--sec--0c737";
export var sig = "factory-module--sig--6b243";
export var story_caption = "factory-module--story_caption--63b3a";
export var swipe_tile = "factory-module--swipe_tile--814ab";
export var swiper_posDots = "factory-module--swiper_pos-dots--f53a0";
export var title_video = "factory-module--title_video--050ac";
export var titles = "factory-module--titles--e5f7a";
export var video = "factory-module--video--74abb";